export default __webpack_public_path__ + "static/media/DORAvatar.66c75869.jpg";